import { TableRow } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { theme } from '@procurify/ui-theme'

const styles = {
  root: {
    height: 0,
    color: theme.colors.textPrimary,
    fontWeight: 400,
    'border-bottom': 'none !important',
  },
}

export const TableBodyAsRowFragmentStyled = withStyles(styles)(TableRow)
